import { Box, Container, Typography } from "@mui/material";
import React, { useEffect } from "react";

export default function PageNotFound() {
  return (
    <Container>
      <Box>
        <Typography>
          Please check the spelling or try searching for something else...!
        </Typography>
        <Typography>
          Page you are looking for is either removed or not found...! Please
          contact Administrator.
        </Typography>
      </Box>
    </Container>
  );
}
